import { CircularProgress } from '@nexelem/components';

export const Loader = () => (
  <div className="flex h-full w-full items-center justify-center">
    <CircularProgress />
  </div>
);
